import { render, staticRenderFns } from "./systemOtherSet.vue?vue&type=template&id=319636cf&scoped=true&"
import script from "./systemOtherSet.vue?vue&type=script&lang=js&"
export * from "./systemOtherSet.vue?vue&type=script&lang=js&"
import style0 from "./systemOtherSet.vue?vue&type=style&index=0&id=319636cf&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "319636cf",
  null
  
)

export default component.exports